<script lang="ts">
	import { _ } from 'svelte-i18n';
	import Card from '@smui/card';
	import Title from '../..//shared/components/common/Title.svelte';
	import FormLoading from '../..//shared/components/common/Loading/FormLoading.svelte';
	import Input from '@smui/textfield';
	import { postData } from '../../shared/stores';
	import { writable } from 'svelte/store';

	const initialData = {
		currentPassword: '',
		newPassword: '',
		confirmNewPassword: '',
	};
	let [data, loading, error] = [writable(initialData), writable(false), null];
	let dataResponse = false;
	function onSubmit() {
		[dataResponse, loading, error] = postData($data, 'api/usersmanagement/cambiopwd');
	}
</script>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="{$_('page.user.change_password.title')}" />
		<div class="flex flex-wrap sm:flex-nowrap sm:space-x-4">
			<button type="submit" form="form" class="btn-white h-14 w-14 sm:h-16 sm:w-16">
				<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
			</button>
		</div>
	</div>
	{#if $loading}
		<FormLoading />
	{:else}
		<form on:submit|preventDefault="{onSubmit}" id="form" class="grid grid-cols-1 md:grid-cols-3">
			<Input
				type="password"
				label="{$_('page.user.change_password.current_password')}"
				bind:value="{$data.currentPassword}"
				name="currentPassword"
				class="md:col-start-2"
			/>
			<Input
				type="password"
				label="{$_('page.user.change_password.new_password')}"
				bind:value="{$data.newPassword}"
				name="newPassword"
				class="md:col-start-2"
			/>
			<Input
				type="password"
				label="{$_('page.user.change_password.confirm_new_password')}"
				bind:value="{$data.confirmNewPassword}"
				name="confirmNewPassword"
				class="md:col-start-2"
			/>
			{#if $data.newPassword !== $data.confirmNewPassword}
				<span class="validation-hint">{$_('page.user.change_password.non-matching_password')}</span>
			{/if}
		</form>
	{/if}
</Card>
